import React, { createContext, type ReactNode } from 'react';
import i18n, { setLanguage as saveLanguage, getLanguage } from '../i18n/i18n';

interface LanguageContextType {
  currentLanguage: string;
  changeLanguage: (lang: string) => Promise<void>;
}

const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined
);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [currentLanguage, setCurrentLanguage] = React.useState<string>(
    i18n.language
  );

  React.useEffect(() => {
    // 保存された言語をロードして設定
    const loadLanguage = async () => {
      const lang = await getLanguage();
      await i18n.changeLanguage(lang);
      setCurrentLanguage(lang);
    };
    loadLanguage();
  }, []);

  const changeLanguage = async (lang: string) => {
    await saveLanguage(lang);
    setCurrentLanguage(lang); // 状態を更新
  };

  return (
    <LanguageContext.Provider value={{ currentLanguage, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = (): LanguageContextType => {
  const context = React.useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
